import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import * as faceapi from 'face-api.js';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: '1.5rem',
    color: '#00d9ff',
  },
  searchInput: {
    padding: '0.75rem 1rem',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    background: 'rgba(0, 0, 0, 0.3)',
    color: '#fff',
    fontSize: '1rem',
    width: '300px',
    outline: 'none',
  },
  card: {
    background: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '16px',
    padding: '1.5rem',
    border: '1px solid rgba(255, 255, 255, 0.1)',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    textAlign: 'left',
    padding: '1rem',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '0.85rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  td: {
    padding: '1rem',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    fontSize: '0.95rem',
  },
  row: {
    transition: 'background 0.2s ease',
  },
  badge: {
    display: 'inline-block',
    padding: '0.25rem 0.75rem',
    borderRadius: '20px',
    fontSize: '0.8rem',
    fontWeight: '600',
  },
  badgeActive: {
    background: 'rgba(0, 230, 118, 0.2)',
    color: '#00e676',
  },
  badgeInactive: {
    background: 'rgba(255, 82, 82, 0.2)',
    color: '#ff5252',
  },
  faceCountContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  faceCount: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    padding: '0.25rem 0.75rem',
    borderRadius: '20px',
    background: 'rgba(0, 217, 255, 0.2)',
    color: '#00d9ff',
    fontSize: '0.85rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  addFaceBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    border: '2px dashed rgba(0, 230, 118, 0.5)',
    background: 'transparent',
    color: '#00e676',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  button: {
    padding: '0.5rem 1rem',
    borderRadius: '6px',
    border: 'none',
    fontSize: '0.85rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginRight: '0.5rem',
  },
  editButton: {
    background: 'rgba(255, 193, 7, 0.2)',
    color: '#ffc107',
  },
  deleteButton: {
    background: 'rgba(255, 82, 82, 0.2)',
    color: '#ff5252',
  },
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modalContent: {
    background: '#1a1a2e',
    borderRadius: '16px',
    padding: '2rem',
    width: '500px',
    maxWidth: '90vw',
    maxHeight: '90vh',
    overflowY: 'auto',
    border: '1px solid rgba(255, 255, 255, 0.1)',
  },
  modalContentWide: {
    width: '800px',
  },
  modalTitle: {
    fontSize: '1.3rem',
    marginBottom: '1.5rem',
    color: '#00d9ff',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
  label: {
    fontSize: '0.85rem',
    color: 'rgba(255, 255, 255, 0.7)',
  },
  input: {
    padding: '0.75rem 1rem',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    background: 'rgba(0, 0, 0, 0.3)',
    color: '#fff',
    fontSize: '1rem',
    outline: 'none',
  },
  select: {
    padding: '0.75rem 1rem',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    background: 'rgba(0, 0, 0, 0.3)',
    color: '#fff',
    fontSize: '1rem',
    outline: 'none',
  },
  modalButtons: {
    display: 'flex',
    gap: '1rem',
    marginTop: '1.5rem',
    justifyContent: 'flex-end',
  },
  primaryButton: {
    background: 'linear-gradient(135deg, #00d9ff 0%, #0099cc 100%)',
    color: '#000',
    padding: '0.75rem 1.5rem',
    fontWeight: '600',
  },
  secondaryButton: {
    background: 'rgba(255, 255, 255, 0.1)',
    color: '#fff',
    padding: '0.75rem 1.5rem',
  },
  successButton: {
    background: 'linear-gradient(135deg, #00e676 0%, #00c853 100%)',
    color: '#000',
    padding: '0.75rem 1.5rem',
    fontWeight: '600',
  },
  emptyState: {
    textAlign: 'center',
    padding: '3rem',
    color: 'rgba(255, 255, 255, 0.5)',
  },
  alert: {
    padding: '1rem',
    borderRadius: '8px',
    marginBottom: '1rem',
  },
  alertSuccess: {
    background: 'rgba(0, 230, 118, 0.2)',
    color: '#00e676',
    border: '1px solid rgba(0, 230, 118, 0.3)',
  },
  alertError: {
    background: 'rgba(255, 82, 82, 0.2)',
    color: '#ff5252',
    border: '1px solid rgba(255, 82, 82, 0.3)',
  },
  // Face management styles
  facesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    marginBottom: '1.5rem',
  },
  faceItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.75rem 1rem',
    background: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
  },
  faceInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  faceIcon: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #00d9ff 0%, #0099cc 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.2rem',
  },
  faceDetails: {
    display: 'flex',
    flexDirection: 'column',
  },
  faceLabel: {
    fontWeight: '600',
    color: '#fff',
  },
  faceMeta: {
    fontSize: '0.8rem',
    color: 'rgba(255, 255, 255, 0.5)',
  },
  deleteFaceBtn: {
    padding: '0.4rem 0.8rem',
    borderRadius: '6px',
    border: 'none',
    background: 'rgba(255, 82, 82, 0.2)',
    color: '#ff5252',
    fontSize: '0.8rem',
    cursor: 'pointer',
  },
  progressBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '1rem',
  },
  progressDot: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    background: 'rgba(255, 255, 255, 0.2)',
    transition: 'all 0.3s ease',
  },
  progressDotFilled: {
    background: '#00e676',
  },
  progressDotEmpty: {
    border: '2px dashed rgba(255, 255, 255, 0.3)',
    background: 'transparent',
  },
  captureSection: {
    marginTop: '1.5rem',
    paddingTop: '1.5rem',
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
  },
  videoContainer: {
    position: 'relative',
    borderRadius: '12px',
    overflow: 'hidden',
    background: '#000',
    marginBottom: '1rem',
    width: '100%',
    height: '360px',
  },
  video: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transform: 'scaleX(-1)',
  },
  canvas: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transform: 'scaleX(-1)',
    pointerEvents: 'none',
  },
  labelSelect: {
    display: 'flex',
    gap: '0.5rem',
    flexWrap: 'wrap',
    marginBottom: '1rem',
  },
  labelOption: {
    padding: '0.5rem 1rem',
    borderRadius: '20px',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    background: 'transparent',
    color: '#fff',
    fontSize: '0.85rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  labelOptionSelected: {
    background: 'rgba(0, 217, 255, 0.3)',
    borderColor: '#00d9ff',
    color: '#00d9ff',
  },
  statusMessage: {
    padding: '0.75rem 1rem',
    borderRadius: '8px',
    background: 'rgba(255, 255, 255, 0.1)',
    fontSize: '0.9rem',
    textAlign: 'center',
    marginBottom: '1rem',
  },
};

const FACE_LABELS = [
  { id: 'frontal', label: 'Frontal', icon: '😐' },
  { id: 'smile', label: 'Smile', icon: '😊' },
  { id: 'left_angle', label: 'Left Angle', icon: '😏' },
  { id: 'right_angle', label: 'Right Angle', icon: '🙂' },
  { id: 'with_glasses', label: 'With Glasses', icon: '🤓' },
];

function PersonsPage() {
  const [persons, setPersons] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isFaceModalOpen, setIsFaceModalOpen] = useState(false);
  const [alert, setAlert] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  
  // Face management state
  const [personFaces, setPersonFaces] = useState([]);
  const [isLoadingFaces, setIsLoadingFaces] = useState(false);
  const [isModelLoaded, setIsModelLoaded] = useState(false);
  const [isCameraActive, setIsCameraActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState('frontal');
  const [captureStatus, setCaptureStatus] = useState('');
  const [isCapturing, setIsCapturing] = useState(false);
  const [stream, setStream] = useState(null);
  
  const videoRef = useRef();
  const canvasRef = useRef();

  useEffect(() => {
    fetchPersons();
    loadFaceModels();
    
    return () => {
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
    };
  }, []);

  const loadFaceModels = async () => {
    try {
      await Promise.all([
        faceapi.nets.ssdMobilenetv1.loadFromUri('/models'),
        faceapi.nets.faceLandmark68Net.loadFromUri('/models'),
        faceapi.nets.faceRecognitionNet.loadFromUri('/models'),
      ]);
      setIsModelLoaded(true);
    } catch (error) {
      console.error('Error loading face models:', error);
    }
  };

  const fetchPersons = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get('/api/persons');
      setPersons(response.data);
    } catch (error) {
      showAlert('error', 'Failed to fetch persons');
    }
    setIsLoading(false);
  };

  const fetchPersonFaces = async (personId) => {
    setIsLoadingFaces(true);
    try {
      const response = await axios.get(`/api/faces/${personId}`);
      setPersonFaces(response.data.faces || []);
    } catch (error) {
      console.error('Error fetching faces:', error);
      setPersonFaces([]);
    }
    setIsLoadingFaces(false);
  };

  const showAlert = (type, message) => {
    setAlert({ type, message });
    setTimeout(() => setAlert(null), 3000);
  };

  const handleEdit = (person) => {
    setSelectedPerson({ ...person });
    setIsModalOpen(true);
  };

  const handleDelete = (person) => {
    setSelectedPerson(person);
    setIsDeleteModalOpen(true);
  };

  const handleManageFaces = async (person) => {
    setSelectedPerson(person);
    await fetchPersonFaces(person.person_id);
    setIsFaceModalOpen(true);
    setCaptureStatus('');
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`/api/persons/${selectedPerson.person_id}`);
      showAlert('success', `${selectedPerson.name} deleted successfully`);
      fetchPersons();
    } catch (error) {
      showAlert('error', error.response?.data?.error || 'Delete failed');
    }
    setIsDeleteModalOpen(false);
    setSelectedPerson(null);
  };

  const handleSave = async () => {
    try {
      await axios.put(`/api/persons/${selectedPerson.person_id}`, selectedPerson);
      showAlert('success', 'Person updated successfully');
      fetchPersons();
      setIsModalOpen(false);
    } catch (error) {
      showAlert('error', error.response?.data?.error || 'Update failed');
    }
  };

  const startCamera = async () => {
    try {
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
      
      setIsCameraActive(true);
      setCaptureStatus('Starting camera...');
      
      const newStream = await navigator.mediaDevices.getUserMedia({
        video: { width: 640, height: 480, facingMode: 'user' }
      });
      
      setStream(newStream);
      
      // Wait for next render cycle to ensure videoRef is available
      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = newStream;
          videoRef.current.play().catch(console.error);
        }
        setCaptureStatus('Camera ready. Position face and capture.');
      }, 100);
      
    } catch (error) {
      setCaptureStatus('Camera error: ' + error.message);
      setIsCameraActive(false);
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      setStream(null);
    }
    setIsCameraActive(false);
  };

  const captureFace = useCallback(async () => {
    if (!isModelLoaded || !videoRef.current || isCapturing) return;
    
    setIsCapturing(true);
    setCaptureStatus('Detecting face...');
    
    try {
      const detection = await faceapi
        .detectSingleFace(videoRef.current)
        .withFaceLandmarks()
        .withFaceDescriptor();

      if (detection) {
        // Draw detection on canvas
        if (canvasRef.current) {
          const displaySize = { width: videoRef.current.videoWidth, height: videoRef.current.videoHeight };
          faceapi.matchDimensions(canvasRef.current, displaySize);
          const resized = faceapi.resizeResults(detection, displaySize);
          const ctx = canvasRef.current.getContext('2d');
          ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
          faceapi.draw.drawDetections(canvasRef.current, resized);
          faceapi.draw.drawFaceLandmarks(canvasRef.current, resized);
        }
        
        const faceVector = Array.from(detection.descriptor);
        const confidence = detection.detection.score;
        const labelInfo = FACE_LABELS.find(l => l.id === selectedLabel);
        
        // Register face
        const response = await axios.post('/api/faces/register', {
          person_id: selectedPerson.person_id,
          face_vector: faceVector,
          label: labelInfo ? `${labelInfo.icon} ${labelInfo.label}` : selectedLabel,
          source_type: 'camera',
          confidence: confidence,
        });
        
        if (response.data.success) {
          setCaptureStatus(`✅ Face captured! (${response.data.face_count}/5)`);
          await fetchPersonFaces(selectedPerson.person_id);
          fetchPersons(); // Refresh the main list
          
          // Clear canvas after delay
          setTimeout(() => {
            if (canvasRef.current) {
              const ctx = canvasRef.current.getContext('2d');
              ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
            }
          }, 1500);
        }
      } else {
        setCaptureStatus('❌ No face detected. Please try again.');
      }
    } catch (error) {
      setCaptureStatus('Error: ' + (error.response?.data?.error || error.message));
    }
    
    setIsCapturing(false);
  }, [isModelLoaded, isCapturing, selectedPerson, selectedLabel]);

  const deleteFace = async (faceId) => {
    try {
      await axios.delete(`/api/faces/${faceId}`);
      await fetchPersonFaces(selectedPerson.person_id);
      fetchPersons();
      showAlert('success', 'Face deleted');
    } catch (error) {
      showAlert('error', 'Failed to delete face');
    }
  };

  const closeFaceModal = () => {
    stopCamera();
    setIsFaceModalOpen(false);
    setSelectedPerson(null);
    setPersonFaces([]);
    setCaptureStatus('');
  };

  const filteredPersons = persons.filter(person =>
    person.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    person.person_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (person.department && person.department.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div style={styles.container}>
      {alert && (
        <div style={{
          ...styles.alert,
          ...(alert.type === 'success' ? styles.alertSuccess : styles.alertError)
        }}>
          {alert.message}
        </div>
      )}
      
      <div style={styles.header}>
        <h2 style={styles.title}>👥 Manage Persons ({persons.length})</h2>
        <input
          type="text"
          placeholder="🔍 Search by name, ID, or department..."
          style={styles.searchInput}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      
      <div style={styles.card}>
        {isLoading ? (
          <div style={styles.emptyState}>Loading...</div>
        ) : filteredPersons.length === 0 ? (
          <div style={styles.emptyState}>
            {persons.length === 0 ? (
              <>
                <p style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>No persons registered yet</p>
                <p>Go to "Add Face" to register new persons</p>
              </>
            ) : (
              <p>No results found for "{searchTerm}"</p>
            )}
          </div>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Person ID</th>
                <th style={styles.th}>Name</th>
                <th style={styles.th}>External ID</th>
                <th style={styles.th}>Department</th>
                <th style={styles.th}>Faces</th>
                <th style={styles.th}>Status</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredPersons.map((person) => (
                <tr key={person.person_id} style={styles.row}>
                  <td style={styles.td}>
                    <code style={{ color: '#00d9ff' }}>{person.person_id}</code>
                  </td>
                  <td style={styles.td}>{person.name}</td>
                  <td style={styles.td}>
                    {person.external_user_id ? (
                      <code style={{ color: '#00e676', fontSize: '0.85rem' }}>{person.external_user_id}</code>
                    ) : (
                      <span style={{ color: 'rgba(255,255,255,0.3)' }}>-</span>
                    )}
                  </td>
                  <td style={styles.td}>{person.department || '-'}</td>
                  <td style={styles.td}>
                    <div style={styles.faceCountContainer}>
                      <span 
                        style={styles.faceCount}
                        onClick={() => handleManageFaces(person)}
                        title="Click to manage faces"
                      >
                        📷 {person.face_count || 0}/5
                      </span>
                      {(parseInt(person.face_count) || 0) < 5 && (
                        <button
                          style={styles.addFaceBtn}
                          onClick={() => handleManageFaces(person)}
                          title="Add more faces"
                        >
                          +
                        </button>
                      )}
                    </div>
                  </td>
                  <td style={styles.td}>
                    <span style={{
                      ...styles.badge,
                      ...(person.status === 'active' ? styles.badgeActive : styles.badgeInactive)
                    }}>
                      {person.status}
                    </span>
                  </td>
                  <td style={styles.td}>
                    <button
                      style={{ ...styles.button, ...styles.editButton }}
                      onClick={() => handleEdit(person)}
                    >
                      ✏️ Edit
                    </button>
                    <button
                      style={{ ...styles.button, ...styles.deleteButton }}
                      onClick={() => handleDelete(person)}
                    >
                      🗑️ Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      
      {/* Face Management Modal */}
      {isFaceModalOpen && selectedPerson && (
        <div style={styles.modal} onClick={closeFaceModal}>
          <div 
            style={{ ...styles.modalContent, ...styles.modalContentWide }} 
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={styles.modalTitle}>
              📷 Manage Faces - {selectedPerson.name}
            </h3>
            
            {/* Progress indicator */}
            <div style={styles.progressBar}>
              <span style={{ marginRight: '0.5rem', fontSize: '0.9rem', color: 'rgba(255,255,255,0.7)' }}>
                Faces:
              </span>
              {[...Array(5)].map((_, i) => (
                <div
                  key={i}
                  style={{
                    ...styles.progressDot,
                    ...(i < personFaces.length ? styles.progressDotFilled : styles.progressDotEmpty),
                  }}
                />
              ))}
              <span style={{ marginLeft: '0.5rem', color: '#00d9ff' }}>
                {personFaces.length}/5
              </span>
            </div>
            
            {/* Existing faces list */}
            {isLoadingFaces ? (
              <div style={{ padding: '1rem', textAlign: 'center' }}>Loading faces...</div>
            ) : personFaces.length > 0 ? (
              <div style={styles.facesList}>
                {personFaces.map((face, index) => (
                  <div key={face.id} style={styles.faceItem}>
                    <div style={styles.faceInfo}>
                      <div style={styles.faceIcon}>
                        {index + 1}
                      </div>
                      <div style={styles.faceDetails}>
                        <span style={styles.faceLabel}>{face.label || `Face ${index + 1}`}</span>
                        <span style={styles.faceMeta}>
                          {face.source_type} • {(face.confidence * 100).toFixed(0)}% • {formatDate(face.created_at)}
                        </span>
                      </div>
                    </div>
                    <button
                      style={styles.deleteFaceBtn}
                      onClick={() => deleteFace(face.id)}
                    >
                      🗑️ Remove
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ padding: '1rem', textAlign: 'center', color: 'rgba(255,255,255,0.5)' }}>
                No faces registered yet. Add faces below.
              </div>
            )}
            
            {/* Add face section */}
            {personFaces.length < 5 && (
              <div style={styles.captureSection}>
                <h4 style={{ marginBottom: '1rem', color: '#00e676' }}>➕ Add New Face</h4>
                
                {/* Label selection */}
                <div style={{ marginBottom: '1rem' }}>
                  <label style={styles.label}>Select face type:</label>
                  <div style={styles.labelSelect}>
                    {FACE_LABELS.map(label => (
                      <button
                        key={label.id}
                        style={{
                          ...styles.labelOption,
                          ...(selectedLabel === label.id ? styles.labelOptionSelected : {}),
                        }}
                        onClick={() => setSelectedLabel(label.id)}
                      >
                        {label.icon} {label.label}
                      </button>
                    ))}
                  </div>
                </div>
                
                {/* Camera section */}
                {isCameraActive ? (
                  <>
                    <div style={styles.videoContainer}>
                      <video
                        ref={videoRef}
                        autoPlay
                        muted
                        playsInline
                        onLoadedMetadata={(e) => e.target.play()}
                        style={styles.video}
                      />
                      <canvas ref={canvasRef} style={styles.canvas} />
                    </div>
                    
                    {captureStatus && (
                      <div style={styles.statusMessage}>{captureStatus}</div>
                    )}
                    
                    <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
                      <button
                        style={{
                          ...styles.button,
                          ...styles.successButton,
                          opacity: isCapturing ? 0.5 : 1,
                        }}
                        onClick={captureFace}
                        disabled={isCapturing || !isModelLoaded}
                      >
                        {isCapturing ? '⏳ Capturing...' : '📸 Capture Face'}
                      </button>
                      <button
                        style={{ ...styles.button, ...styles.secondaryButton }}
                        onClick={stopCamera}
                      >
                        ⏹️ Stop Camera
                      </button>
                    </div>
                  </>
                ) : (
                  <button
                    style={{ ...styles.button, ...styles.primaryButton, width: '100%' }}
                    onClick={startCamera}
                    disabled={!isModelLoaded}
                  >
                    {isModelLoaded ? '📹 Start Camera' : '⏳ Loading models...'}
                  </button>
                )}
              </div>
            )}
            
            {personFaces.length >= 5 && (
              <div style={{ 
                padding: '1rem', 
                background: 'rgba(0, 230, 118, 0.1)', 
                borderRadius: '8px',
                textAlign: 'center',
                color: '#00e676',
                marginTop: '1rem'
              }}>
                ✅ Maximum faces reached (5/5). Delete existing faces to add new ones.
              </div>
            )}
            
            <div style={styles.modalButtons}>
              <button
                style={{ ...styles.button, ...styles.secondaryButton }}
                onClick={closeFaceModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Edit Modal */}
      {isModalOpen && selectedPerson && (
        <div style={styles.modal} onClick={() => setIsModalOpen(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h3 style={styles.modalTitle}>✏️ Edit Person</h3>
            <div style={styles.form}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Person ID</label>
                <input
                  type="text"
                  value={selectedPerson.person_id}
                  style={{ ...styles.input, opacity: 0.5 }}
                  disabled
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Name</label>
                <input
                  type="text"
                  value={selectedPerson.name}
                  onChange={(e) => setSelectedPerson({ ...selectedPerson, name: e.target.value })}
                  style={styles.input}
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Email</label>
                <input
                  type="email"
                  value={selectedPerson.email || ''}
                  onChange={(e) => setSelectedPerson({ ...selectedPerson, email: e.target.value })}
                  style={styles.input}
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Department</label>
                <input
                  type="text"
                  value={selectedPerson.department || ''}
                  onChange={(e) => setSelectedPerson({ ...selectedPerson, department: e.target.value })}
                  style={styles.input}
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Designation</label>
                <input
                  type="text"
                  value={selectedPerson.designation || ''}
                  onChange={(e) => setSelectedPerson({ ...selectedPerson, designation: e.target.value })}
                  style={styles.input}
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Phone</label>
                <input
                  type="tel"
                  value={selectedPerson.phone || ''}
                  onChange={(e) => setSelectedPerson({ ...selectedPerson, phone: e.target.value })}
                  style={styles.input}
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>External User ID</label>
                <input
                  type="text"
                  value={selectedPerson.external_user_id || ''}
                  onChange={(e) => setSelectedPerson({ ...selectedPerson, external_user_id: e.target.value })}
                  style={styles.input}
                  placeholder="Your external system's user ID"
                />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Status</label>
                <select
                  value={selectedPerson.status}
                  onChange={(e) => setSelectedPerson({ ...selectedPerson, status: e.target.value })}
                  style={styles.select}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
              <div style={styles.modalButtons}>
                <button
                  style={{ ...styles.button, ...styles.secondaryButton }}
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  style={{ ...styles.button, ...styles.primaryButton }}
                  onClick={handleSave}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && selectedPerson && (
        <div style={styles.modal} onClick={() => setIsDeleteModalOpen(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ ...styles.modalTitle, color: '#ff5252' }}>⚠️ Confirm Delete</h3>
            <p style={{ marginBottom: '1rem' }}>
              Are you sure you want to delete <strong>{selectedPerson.name}</strong>?
            </p>
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.9rem' }}>
              This will also remove all {selectedPerson.face_count || 0} face embeddings associated with this person.
              This action cannot be undone.
            </p>
            <div style={styles.modalButtons}>
              <button
                style={{ ...styles.button, ...styles.secondaryButton }}
                onClick={() => setIsDeleteModalOpen(false)}
              >
                Cancel
              </button>
              <button
                style={{ ...styles.button, ...styles.deleteButton, padding: '0.75rem 1.5rem' }}
                onClick={confirmDelete}
              >
                Delete Person
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PersonsPage;
